import cogoToast from 'cogo-toast';

import CaseUtil from '@common/lib/caseUtil';
import achievementsApi from '@profile/api/achievements';

const GET_ACHIEVEMENTS_INIT = 'PROFILE/GET_ACHIEVEMENTS_INIT';
const GET_ACHIEVEMENTS_DONE = 'PROFILE/GET_ACHIEVEMENTS_DONE';
const GET_ACHIEVEMENTS_ERROR = 'PROFILE/GET_ACHIEVEMENTS_ERROR';

const GET_ACHIEVEMENTS_DATA_INIT = 'PROFILE/GET_ACHIEVEMENTS_DATA_INIT';
const GET_ACHIEVEMENTS_DATA_DONE = 'PROFILE/GET_ACHIEVEMENTS_DATA_DONE';
const GET_ACHIEVEMENTS_DATA_ERROR = 'PROFILE/GET_ACHIEVEMENTS_DATA_ERROR';

const GET_LOCALE_INIT = 'PROFILE/GET_LOCALE_INIT';
const GET_LOCALE_DONE = 'PROFILE/GET_LOCALE_DONE';
const GET_LOCALE_ERROR = 'PROFILE/GET_LOCALE_ERROR';

const SHOW_ACHIEVEMENTS_MODAL_DONE = 'PROFILE/SHOW_ACHIEVEMENTS_MODAL_DONE';

export function getAchievements() {
  return async (dispatch) => {
    dispatch({ type: GET_ACHIEVEMENTS_INIT });
    try {
      const json = await achievementsApi.fetchAchievements();
      const response = CaseUtil.toCase('camelCase', json);
      dispatch({ type: GET_ACHIEVEMENTS_DONE, payload: response });
    } catch (error) {
      dispatch({ type: GET_ACHIEVEMENTS_ERROR });
      cogoToast.error('Something went wrong! Please try again.');
    }
  };
}

export function getLocale() {
  return async (dispatch) => {
    dispatch({ type: GET_LOCALE_INIT });
    try {
      const json = await achievementsApi.fetchLocale();
      const response = CaseUtil.toCase('camelCase', json);
      dispatch({ type: GET_LOCALE_DONE, payload: response });
    } catch (error) {
      dispatch({ type: GET_LOCALE_ERROR });
      cogoToast.error('Something went wrong! Please try again.');
    }
  };
}

export function showAchievementsModal(toggle) {
  return { type: SHOW_ACHIEVEMENTS_MODAL_DONE, payload: toggle };
}

export function getAchievementData(nudgeLabel) {
  return async (dispatch) => {
    dispatch({ type: GET_ACHIEVEMENTS_DATA_INIT });
    try {
      const json = await achievementsApi.fetchAchievementData(nudgeLabel);
      const response = CaseUtil.toCase('camelCase', json);
      dispatch({
        type: GET_ACHIEVEMENTS_DATA_DONE,
        payload: { response, nudgeLabel },
      });
    } catch (error) {
      dispatch({ type: GET_ACHIEVEMENTS_DATA_ERROR });
      cogoToast.error('Something went wrong! Please try again.');
    }
  };
}

const initialState = {
  isLoading: false,
  isLoadingAchievements: false,
  isLoadingAchievementsData: false,
  isLoadingLocale: false,
  achievements: [],
  shareableLink: undefined,
  locale: '',
  showAchievementModal: false,
  nudgeLabel: undefined,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ACHIEVEMENTS_INIT:
      return {
        ...state,
        isLoading: true,
        isLoadingAchievements: true,
      };
    case GET_ACHIEVEMENTS_DONE:
      return {
        ...state,
        isLoading: false
          || state.isLoadingAchievementsData || state.isLoadingLocale,
        isLoadingAchievements: false,
        achievements: action.payload.achievements,
      };
    case GET_ACHIEVEMENTS_ERROR:
      return {
        ...state,
        isLoading: false
          || state.isLoadingAchievementsData || state.isLoadingLocale,
        isLoadingAchievements: false,
      };
    case GET_LOCALE_INIT:
      return {
        ...state,
        isLoading: true,
        isLoadingLocale: true,
      };
    case GET_LOCALE_DONE:
      return {
        ...state,
        isLoading: false
          || state.isLoadingAchievements || state.isLoadingAchievementsData,
        isLoadingLocale: false,
        locale: action.payload.locale,
      };
    case GET_LOCALE_ERROR:
      return {
        ...state,
        isLoading: false
        || state.isLoadingAchievements || state.isLoadingAchievementsData,
        isLoadingLocale: false,
      };
    case GET_ACHIEVEMENTS_DATA_INIT:
      return {
        ...state,
        isLoading: true,
        isLoadingAchievementsData: true,
      };
    case GET_ACHIEVEMENTS_DATA_DONE:
      return {
        ...state,
        isLoading: false
          || state.isLoadingAchievements || state.isLoadingLocale,
        isLoadingAchievementsData: false,
        shareableLink: action.payload.response.shareableLink,
        nudgeLabel: action.payload.nudgeLabel,
      };
    case GET_ACHIEVEMENTS_DATA_ERROR:
      return {
        ...state,
        isLoading: false
        || state.isLoadingAchievements || state.isLoadingLocale,
        isLoadingAchievementsData: false,
      };
    case SHOW_ACHIEVEMENTS_MODAL_DONE:
      return { ...state, showAchievementModal: action.payload };
    default:
      return state;
  }
}
